import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-print" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ZebraPrintView = _resolveComponent("ZebraPrintView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("li", null, [
      _createElementVNode("a", {
        class: _normalizeClass(_ctx.linkClass),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.zebraPrintViewVisible = true))
      }, _hoisted_2, 2)
    ]),
    (_ctx.zebraPrintViewVisible)
      ? (_openBlock(), _createBlock(_component_ZebraPrintView, {
          key: 0,
          show: _ctx.zebraPrintViewVisible,
          "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.zebraPrintViewVisible) = $event))
        }, null, 8, ["show"]))
      : _createCommentVNode("", true)
  ], 64))
}